const CONFIG = {
  BASE_URL: 'https://story-api.dicoding.dev/v1', // ini dicoding
  VAPID_KEY: 'BCCs2eonMI-6H2ctvFaWg-UYdDv387Vno_bzUzALpB442r2lCnsHmtrx8biyPi_E-1fSGABK_Qs_GlvPoJJqxbk', // ini dicoding
  MAP_TILER_KEY: '7UXcqU09CnFCptnMqeLJ', // ini map tiler cloud
  AVATAR_BASE_URL: 'https://api.dicebear.com/9.x/micah/webp',
  APP_NAME: 'HeliaEDU',
  APP_DESCRIPTION: 'Platform sosial media untuk programmer berbagi pengalaman dan pengetahuan coding',
  APP_VERSION: '1.0.0',
  AUTHOR: 'Nanang Hendy S',
  AUTHOR_EMAIL: 'nananghendystwn@gmail.com', // kontak min kalau ada project, mungkin bisa bantu.
  DEPLOYMENT_URL: 'https://heliaedu-lite.nananghendy.my.id'
};

export default CONFIG;
